import { useState } from "react";
import check from "../../../../../../assets/images/svgs/check.svg";
import checkRound from "../../../../../../assets/images/svgs/checkRound.svg";
import { parseIfStringify } from "../../../../../../functions/common";

const SingleChoiceText = ({ data, handleAnswer, answers }) => {
  const answersArray = Object.entries(data?.answers || {})
    .map(([key, value]) => ({
      key,
      value,
    }))
    ?.filter((v) => v?.value);
  const [textArea, setTextArea] = useState("")
  const splittesAnswer = answers?.[data?.refCode]?.split(" + ");
  const selectedOption = splittesAnswer?.[0] ?? "";
  const inputText = parseIfStringify(splittesAnswer?.[1] ?? []);

  const handleOptionSelect = (value) => {
    handleAnswer(`${value} + ${textArea ?? ""}`);
  };

  const handleAdditionalTextChange = (value) => {
    handleAnswer(`${selectedOption} + ${value ?? ""}`);
  };

  return (
    <div className="options">
      <div className="single__choice">
        {answersArray?.map((v, i) => {
          return (
            <button onClick={() => handleOptionSelect(v?.value)} key={i}>
              <div>
                <img
                  src={selectedOption === v?.value ? check : checkRound}
                  className="check__box"
                  alt="check_box"
                />
              </div>
              <div>{v?.value}</div>
            </button>
          );
        })}
      </div>
      <div className="yes__text__comment">
        <p>{data?.prompt}</p>
        <textarea
          rows="5"
          value={inputText}
          onChange={(e) => {
            const updatedText = e.target.value;
            setTextArea(updatedText);
            handleAdditionalTextChange(updatedText);
          }}
          required={true}
        ></textarea>
      </div>
    </div>
  );
};

export default SingleChoiceText;
